import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import OlitaskHeaderIcon from "components/olitask/OlitaskHeaderIcon";
import OliveebProductAds from "components/promotions/OliveebProductAds";
import { useAuth } from "contexts/AuthContext";
import { useWorkspace } from "contexts/WorkspaceContext";
import paths from "routes/paths";

const { Text } = Typography;

const isHelperUse = (value) => String(value || "").toUpperCase() === "HELPER";

export default function RightSideSection() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    workspaceWorkMode,
  } = useWorkspace();
  const isHelperWorkspace = isHelperUse(workspaceWorkMode);
  const userId = user?.id || user?.userId || user?.profileId || "";
  const activeNearbyRequestsPath = `${paths.myTasks}?nearby=active&filter=ACTIVE`;

  const primaryAction = isHelperWorkspace
    ? {
        label: "Active Nearby Requests",
        icon: "helper",
        onClick: () => navigate(activeNearbyRequestsPath),
      }
    : {
        label: "Request Help",
        icon: "requester",
        onClick: () => navigate(paths.taskCreateGeneral),
      };

  const taskLinks = isHelperWorkspace
    ? [
        { label: "Active Nearby Requests", icon: "helper", to: activeNearbyRequestsPath },
        { label: "My Helper Profile", icon: "person", to: userId ? paths.helperProfileDetails(userId) : paths.profile },
        { label: "Professional Profiles", icon: "apps", to: paths.professionalProfiles },
      ]
    : [
        { label: "General Help Request", icon: "requester", to: paths.taskCreateGeneral },
        { label: "Travo Request", icon: "apps", to: paths.taskCreateTravo },
        { label: "Care Support Request", icon: "person", to: paths.taskCreateCare },
        { label: "My Requests", icon: "apps", to: paths.myTasks },
      ];

  return (
    <aside className="pm-right-section" aria-label="Olitask task actions">
      <div className="pm-right-menu-column">
        <OliveebProductAds className="pm-right-ads-section pm-right-product-ads-top" compact intervalMs={5200} />

        <section className="pm-right-panel pm-right-context">
          <div className="pm-right-context-icons">
            <OlitaskHeaderIcon name={isHelperWorkspace ? "helper" : "requester"} size={16} />
          </div>
          <Text className="pm-right-eyebrow">
            {isHelperWorkspace ? "Task Execution" : "Task Requests"}
          </Text>
          <Text className="pm-right-title">
            {isHelperWorkspace ? "Find and complete nearby requests." : "Create and manage help requests."}
          </Text>
          <Button
            block
            className="pm-right-primary"
            icon={<OlitaskHeaderIcon name={primaryAction.icon} size={18} />}
            onClick={primaryAction.onClick}
            type="primary"
          >
            {primaryAction.label}
          </Button>
        </section>

        <section className="pm-right-panel">
          <div className="pm-right-section-head">
            <Text strong>{isHelperWorkspace ? "Execution" : "Requests"}</Text>
          </div>
          <div className="pm-right-link-list">
            {taskLinks.map((link) => (
              <button
                type="button"
                className="pm-right-link"
                key={link.label}
                onClick={() => navigate(link.to)}
              >
                <span className="pm-right-link-icon">
                  <OlitaskHeaderIcon name={link.icon} size={18} />
                </span>
                <span>{link.label}</span>
                <OlitaskHeaderIcon className="pm-right-link-tail" name="chevron" size={15} />
              </button>
            ))}
          </div>
        </section>

        <section className="pm-right-tip">
          <Text>
            {isHelperWorkspace
              ? "Tip: Keep task status current so requesters can follow progress."
              : "Tip: Clear task details get faster responses and better matches."}
          </Text>
        </section>

      </div>
    </aside>
  );
}
